import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft, FaClipboardList } from "react-icons/fa";
import Practice from "../Components/Practice";
import formatName from "../utils/formatName";
import "../App.css";
import "../Styles/AdminPages.css";

const brandBlue = "#263F86";
const borderColor = "#EEF0F4";

// Admin view of one learner's practice assessments (opened from the Leaderboard).
function LearnerPracticePage() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { userId, username } = state || {};

  return (
    <div
      style={{
        background: "#F5F6FA",
        minHeight: "100vh",
        fontFamily: "Manrope-Regular",
        padding: "24px 0",
      }}
    >
      <div className="container">
        <section
          className="admin-page"
          aria-labelledby="learner-practice-title"
          style={{ minHeight: "auto" }}
        >
          <div className="admin-page__header">
            <div className="d-flex align-items-center gap-3">
              <button
                type="button"
                onClick={() => navigate(-1)}
                aria-label="Back"
                title="Back"
                style={{
                  width: "42px",
                  height: "42px",
                  borderRadius: "12px",
                  border: `1px solid ${borderColor}`,
                  background: "#ffffff",
                  color: brandBlue,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <FaArrowLeft size={14} />
              </button>

              <div style={{ textAlign: "left" }}>
                <p className="admin-page__eyebrow">LEARNER RESULTS</p>
                <h1 id="learner-practice-title">
                  {formatName(username) || "Learner"}
                </h1>
                <p className="admin-page__intro">
                  Review this learner&apos;s practice assessments and attempts.
                </p>
              </div>
            </div>
          </div>

          <div
            style={{
              background: "#ffffff",
              borderRadius: "18px",
              padding: "20px",
              boxShadow: "0 8px 24px rgba(0,0,0,0.04)",
              border: `1px solid ${borderColor}`,
            }}
          >
            <div className="d-flex align-items-center gap-2 mb-3">
              <FaClipboardList color={brandBlue} />
              <h6 className="fw-bold mb-0">Practice Assessment</h6>
            </div>

            {userId ? (
              <Practice viewUserId={userId} viewUserName={username} embedded />
            ) : (
              <p
                className="text-center py-4 mb-0"
                style={{ color: "#5F6B7A", fontWeight: 600 }}
              >
                No learner selected. Please go back to the Leaderboard and
                choose View.
              </p>
            )}
          </div>
        </section>
      </div>
    </div>
  );
}

export default LearnerPracticePage;
